import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Button, createStyles, Drawer, Grid, Hidden, Icon, IconButton, makeStyles, Tab, Tabs, Theme, Tooltip, Typography } from '@material-ui/core';
import { Column, Options } from 'material-table';

import { NewsStatus } from '../enum/NewsStatus';
import { NewsContext } from '../NewsContext';
import { NewsModel } from '../../../Models/NewsModel';
import { theme } from '../../../theme';
import NewsService from '../../../Services/NewsService';
import { TableCommon } from '../../../shared/components/TableCommon';
import { ClassificationStatus } from '../enum/ClassificationStatus';
import { getTableColumn } from '../../../shared/operators';
import { HomeContext } from '../../Home/HomeContext';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { TableLoading } from '../../../shared/components/TableLoading';

const useStyles = makeStyles((theme: Theme) => createStyles({
    drawer: {
        width: '528px',
        flexShrink: 0,
    },
    drawerPaper: {
        width: '528px',
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1)
    },
    listGrid: {
        marginLeft: theme.spacing(-1.5),
        height: '82%',
        overflow: 'hidden',
        marginBottom: theme.spacing(1),
    },
    buttonGrid: {
        alignItems: 'center',
        paddingTop: theme.spacing(1),
    }
}));
export interface INewsListProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    setLoading: (loading: boolean) => void,
    spreadsheetId: number | null,
}

export default function NewsList({ open, setOpen, spreadsheetId, setLoading }: INewsListProps) {
    const classes = useStyles();

    const newsContext = React.useContext(NewsContext);
    const homeContext = React.useContext(HomeContext);
    const [showConfirmNotClassify, setShowConfirmNotClassify] = React.useState(false);

    const [listNewsNotClassify, setListNewsNotClassify] = React.useState<NewsModel[]>([]);


    React.useEffect(() => {
        fetchNewsInLists();
    }, [newsContext.newsList]);

    React.useEffect(() => {
        fecthNews();
    }, [newsContext.listNewsPending]);

    React.useEffect(() => {
        fecthNews();
    }, [newsContext.newsIndex]);

    const fetchNewsInLists = () => {
        newsContext.setListNewsPending(
            newsContext.newsList.reduce(function (filtered: NewsModel[], news: NewsModel) {
                if (news.status == NewsStatus.PENDING)
                    filtered.push(news);
                return filtered;
            }, [])
        );
        setListNewsNotClassify(
            newsContext.newsList.reduce(function (filtered: NewsModel[], news: NewsModel) {
                if (news.status == NewsStatus.NOT_CLASSIFY)
                    filtered.push(news);
                return filtered;
            }, [])
        );
    };

    const fecthNews = () => {
        if (newsContext.newsIndex >= 0) {
            let list: NewsModel[] = [...newsContext.newsList];
            if (newsContext.tabListSelected == 1) {
                list = [...newsContext.listNewsPending];
            }
            if (newsContext.newsIndex < list.length)
                newsContext.setNewsCurrentId(list[newsContext.newsIndex].id);
            else //nesse caso eu estava na última notícia e não é possível passar pra frente            
                newsContext.setNewsCurrentId(null);
        }
    };

    const updateNewsList = () => {
        if (spreadsheetId) {
            NewsService.newsService(spreadsheetId)
                .getAll()
                .then((res: AxiosResponse) => { newsContext.setNewsList(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };

    const getStatus = (news: NewsModel) => {
        if (news.id == newsContext.newsCurrentId && news.status != NewsStatus.NOT_CLASSIFY && news.status != NewsStatus.CLASSIFIED) {
            news.status = NewsStatus.CLASSIFYING;
        }
        switch (news.status) {
            case NewsStatus.CLASSIFYING:
                return (<Icon fontSize="small">more_horiz</Icon>);
            case NewsStatus.PENDING:
                return (<Icon fontSize="small">minimize</Icon>);
            case NewsStatus.CLASSIFIED:
                return (getNewsIdTooltip(news));
            default:
                return (<></>);
        }
    };

    const getNewsIdTooltip = (news: NewsModel) => {
        let idTooltip = '';

        if (news.metricIds && news.metricIds != '') {
            idTooltip = `ID Metric: ${news.metricIds}`;
        }
        else {
            idTooltip = `ID Plataforma: ${news.classificationId}`;
        }

        return (
            <Tooltip title={idTooltip}>
                <Icon fontSize="small" color="primary">check</Icon>
            </Tooltip>
        );
    };

    const getData = () => {
        switch (newsContext.tabListSelected) {
            case 0:
                return newsContext.newsList;
            case 1:
                return newsContext.listNewsPending;
            case 2:
                return listNewsNotClassify;
            default:
                return newsContext.newsList;
        }
    };

    const getEmptyText = () => {
        switch (newsContext.tabListSelected) {
            case 0:
                return 'Nenhuma notícia.';
            case 1:
                return 'Nenhuma notícia pendente.';
            case 2:
                return 'Nenhuma notícia descartada.';
            default:
                return 'Nenhuma notícia.';
        }
    };

    const getRowNotClassify = (rowData: NewsModel) => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="body2">
                        {rowData.title}
                    </Typography>
                </Grid>
                <Button
                    size="small"
                    startIcon={<Icon>undo</Icon>}
                    onClick={() => handleBackNewsToPending(rowData.id)}>
                    Mover para pendentes
                </Button>
            </Grid>
        );
    };

    const getTitleDisabledForRemovedClassification = (rowData: NewsModel) => {
        if (rowData.status == NewsStatus.CLASSIFIED) {
            if (rowData.classificationStatus == ClassificationStatus.REMOVED)
                return theme.palette.text.disabled;
            else
                return theme.palette.text.primary;
        }
        else if (rowData.status == NewsStatus.NOT_CLASSIFY)
            return theme.palette.text.disabled;
        else
            return theme.palette.text.primary;
    };

    const handleBackNewsToPending = (newsId: number) => {
        if (spreadsheetId && newsId) {
            NewsService.updateStatusNews(spreadsheetId, newsId, NewsStatus.PENDING)
                .then(() => updateNewsList())
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };
    const handleNewsToNotClassify = () => {
        setShowConfirmNotClassify(false);
        if (spreadsheetId) {
            setLoading(true);
            NewsService.updatePendingNews(spreadsheetId, NewsStatus.NOT_CLASSIFY)
                .then(() => { window.location.reload(); })
                .catch((error: AxiosError) => { homeContext.showError('', error); })
                .finally(() => { setLoading(false); });
        }
    };

    const handleRowClick = (rowData: NewsModel) => {
        newsContext.setNewsCurrentId(rowData.id);
        newsContext.setKeepData(false);

        let found = -1;
        if (newsContext.tabListSelected == 0)
            found = newsContext.newsList.findIndex(x => x.id == rowData.id);
        else if (newsContext.tabListSelected == 1)
            found = newsContext.listNewsPending.findIndex(x => x.id == rowData.id);

        newsContext.setNewsIndex(found);
    };

    const tableDiscardedNewsColumns: Column<NewsModel>[] = [
        {
            title: 'Título',
            type: 'string',
            align: 'left',
            sorting: true,
            field: 'title',
            render: (rowData: NewsModel) => getRowNotClassify(rowData)
        }
    ];

    const tableDiscardedNewsOptions: Options<NewsModel> = {
        filtering: false,
        sorting: false,
        paging: false,
        showTitle: false,
        toolbar: false,
        headerStyle: {
            fontSize: '14px',
            whiteSpace: 'nowrap'
        }
    };

    const tableNewsColumns: Column<NewsModel>[] = [
        getTableColumn('Título', 'title', 'string', 'left', undefined, undefined, true),
        {
            title: 'Classificada?',
            type: 'string',
            align: 'center',
            sorting: false,
            render: rowData => getStatus(rowData)
        },
    ];

    const tableNewsOptions: Options<NewsModel> = {
        filtering: false,
        sorting: false,
        paging: false,
        showTitle: false,
        toolbar: false,
        rowStyle: (rowData: NewsModel) => ({
            color: getTitleDisabledForRemovedClassification(rowData),
            backgroundColor: (newsContext.newsCurrentId === rowData.id)
                ? theme.palette.action.disabledBackground
                : theme.palette.background.default
        }),
        headerStyle: {
            fontSize: '14px',
            whiteSpace: 'nowrap'
        },
    };

    return (
        <>
            <Drawer
                variant="persistent"
                anchor='left'
                open={open}
                className={classes.drawer}
                classes={{ paper: classes.drawerPaper }}>
                <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    spacing={2}>
                    <Grid item>
                        <Typography variant="h6">
                            Lista de notícias
                        </Typography>
                    </Grid>

                    <Grid item>
                        <IconButton onClick={() => setOpen(false)}>
                            <Icon color="primary">chevron_left</Icon>
                        </IconButton>
                    </Grid>
                </Grid>

                <Tabs
                    value={newsContext.tabListSelected}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={(_, newValue: number) => newsContext.setTabListSelected(newValue)}
                    aria-label="disabled tabs example">
                    <Tab label={`Todas (${newsContext.newsList.length})`} />
                    <Tab label={`Pendentes (${newsContext.listNewsPending.length})`} />
                    <Tab label={`Descartadas (${listNewsNotClassify.length})`} />
                </Tabs>
                <Grid container className={classes.listGrid}>
                    {newsContext.tabListSelected == 2
                        ? (
                            <TableCommon
                                tableData={listNewsNotClassify}
                                tableColumns={tableDiscardedNewsColumns}
                                extraOptions={tableDiscardedNewsOptions}
                                emptyDataSourceMessage={getEmptyText()}
                                style={{ overflowY: 'scroll', height: 'calc(100vh - 140px)' }}
                                paperElevation={0}
                                cssProperties={{
                                    tablePadding: '16px',
                                    tableBorderRadius: '0px',
                                }} />
                        ) : (
                            <TableCommon
                                tableData={getData()}
                                onRowClick={(_, rowData: NewsModel) => handleRowClick(rowData)}
                                tableColumns={tableNewsColumns}
                                extraOptions={tableNewsOptions}
                                emptyDataSourceMessage={getEmptyText()}
                                style={{ overflowY: 'scroll', height: 'calc(100vh - 140px)', paddingBottom: '3rem' }}
                                paperElevation={0}
                                cssProperties={{
                                    tablePadding: '16px',
                                    tableBorderRadius: '0px',
                                }} />
                        )
                    }
                </Grid>
                {newsContext.tabListSelected == 2
                    ? (<></>) : (
                        <Grid container className={classes.buttonGrid}>
                            <Grid item>
                                <Button
                                    variant='outlined'
                                    color='primary'
                                    size='large'
                                    onClick={() => setShowConfirmNotClassify(true)}>
                                    Descartar não Classificadas
                                </Button>
                            </Grid>
                        </Grid>)
                }
            </Drawer>
            <BasicConfirmDialog
                title={'Deseja realmente descartar em lote?'}
                description={'Ao descartar em lote, todas as notícias ainda não classificadas serão descartadas.'}
                handleFirstButton={handleNewsToNotClassify}
                handleSecondButton={() => setShowConfirmNotClassify(false)}
                textFirstButton={'Descartar'}
                textSecondButton={'Cancelar'}
                open={showConfirmNotClassify} />
        </>
    );
}